import { RowFlag } from '~support-at-home/lib/bulkUpdate';
import { BulkUpdateRow } from '~support-at-home/lib/contributionSelection';

import { Column, Row } from '~components/table-view';
import { genericCellRender } from '~components/table-view/columnRenderers';
import BulkPreviewRateCell from '~support-at-home/components/config/contributions/BulkPreviewRateCell';
import TruncatedText from '~support-at-home/components/config/contributions/TruncatedText';

interface BulkPreviewParams {
  // The new rate, or null until a valid one is typed.
  proportion: number | null;
  // The effective date, or null until a valid one is entered.
  validDate: string | null;
  // Client-side pre-check reasons, by row id.
  flags: ReadonlyMap<string, RowFlag>;
  // Server rejection reasons, by row id.
  serverReasons: ReadonlyMap<string, string>;
}

// Read-only, one line per row: each text cell is cut short with an ellipsis (full text on hover), and
// the widths are percentages of the modal's table so the Rate cell has room for its note.
const text = (field: keyof BulkUpdateRow) =>
  genericCellRender((_value, row) => TruncatedText({ text: String(row?.[field] ?? '') }));

// Not memoised: the Rate cell closes over the modal's live inputs.
const bulkPreviewColumns = ({ proportion, validDate, flags, serverReasons }: BulkPreviewParams): Column[] => [
  {
    id: 'client_name',
    header: 'Client',
    type: 'readonly',
    style: { width: '26%' },
    isEditable: false,
    renderReadOnly: text('client_name'),
  },
  {
    id: 'category_name',
    header: 'Category',
    type: 'readonly',
    style: { width: '20%' },
    isEditable: false,
    renderReadOnly: text('category_name'),
  },
  {
    id: 'funding_source_name',
    header: 'Funding Source',
    type: 'readonly',
    style: { width: '22%' },
    isEditable: false,
    renderReadOnly: text('funding_source_name'),
  },
  {
    id: 'contrib_proportion',
    header: 'Rate',
    type: 'readonly',
    style: { width: '32%' },
    isEditable: false,
    renderReadOnly: (_value: unknown, row: Row) =>
      BulkPreviewRateCell({
        row: row as BulkUpdateRow,
        proportion,
        validDate,
        flag: flags.get(String(row.id)),
        serverReason: serverReasons.get(String(row.id)),
      }),
  },
];

export default bulkPreviewColumns;
